<ion-item button (click)="openDetail.emit(item)">
  <ion-label class="ion-text-wrap item-label">
    <h3 class="item-label__title">
      <span class="skeleton">{{ item.title }}</span>
    </h3>
  </ion-label>
</ion-item>
